import { render, staticRenderFns } from "./ImportCard.vue?vue&type=template&id=89bc6b9c"
import script from "./ImportCard.vue?vue&type=script&lang=js"
export * from "./ImportCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports